<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Kidney Function and Oxalosis Tests
        </h2>

        <h5 class="font-semibold mb-3">Kidney function test results</h5>
        
        <ul class="list-disc pl-4  font-light mb-6">
            <li>GFR at presentation was <span class="font-semibold">3 mL/min/1.73 m<sup>2</sup></span></li>
            <li>Plain CTU showed bilateral staghorn calculi and kidney cortical <span class="font-semibold">nephrocalcinosis</span> but no hydronephrosis or hydroureter</li>
            <li>The urinary bladder was distended, with no wall thickening or bladder stones</li>
        </ul>
        
        <h5 class="font-semibold mb-3">Systemic oxalosis screening</h5>
        <ul class="list-disc pl-4  font-light">
            <li>Eye examination did not identify any crystalline ocular deposits</li>
            <li>
                Echocardiography showed mild left ventricular hypertrophy with ejection fraction of 60%; otherwise, the heart was <br />structurally normal
            </li>
            <li>Bone marrow examination was not performed</li>
        </ul>

    </div>
</template>
